module.exports = __webpack_public_path__ + "img/simulator_logo.d6f917a5.svg";